<app-modal
  #createEditPlanModal
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    showFooter: false
  }"
  (isClosing)="clearForm()"
  (isDismissing)="clearForm()">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="createEditPlanModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <ng-container *ngIf="form">
    <form [formGroup]="form">
      <label for="plan-title" class="form-label">Title:</label>
      <div class="input-group mb-2">
        <input
          formControlName="title"
          type="text"
          class="form-control"
          id="plan-title"
          aria-label="Plan Title"
          [ngClass]="{
            'is-invalid': formSubmitted && f['title'].errors
          }" />
      </div>
      <label for="plan-audience" class="form-label">Description:</label>
      <div class="input-group mb-2">
        <textarea
          formControlName="description"
          type="text"
          class="form-control"
          id="plan-description"
          aria-label="Plan Description"
          [ngClass]="{
            'is-invalid': formSubmitted && f['description'].errors
          }"></textarea>
      </div>

      <label for="plan-naming-convention" class="form-label"
        >Hierarchy Naming Convention:</label
      >
      <div class="row">
        <div class="col-6">
          <ng-select
            [clearable]="false"
            formControlName="level1"
            id="plan-level1"
            aria-label="Plan level1"
            [ngClass]="{
              'is-invalid': formSubmitted && f['level1'].errors
            }">
            <ng-option value="Phase">Phase</ng-option>
            <ng-option value="Goal">Goal</ng-option>
            <ng-option value="Strategy">Strategy</ng-option>
            <ng-option value="Gate">Gate</ng-option>
            <ng-option value="Step">Step</ng-option>
          </ng-select>
        </div>
      </div>
      <div class="row my-3 align-items-center">
        <div class="col-1 offset-1">
          <i class="bi bi-arrow-return-right me-3"></i>
        </div>
        <div class="col-6">
          <ng-select
            [clearable]="false"
            formControlName="level2"
            id="plan-level2"
            aria-label="Plan level2"
            [ngClass]="{
              'is-invalid': formSubmitted && f['level2'].errors
            }">
            <ng-option value="Deliverable">Deliverable</ng-option>
            <ng-option value="Specific Result">Specific Result</ng-option>
            <ng-option value="Objective">Objective</ng-option>
          </ng-select>
        </div>
      </div>
      <div class="row mb-2 align-items-center">
        <div class="col-1 offset-3">
          <i class="bi bi-arrow-return-right me-3"></i>
        </div>
        <div class="col-6">
          <ng-select
            [clearable]="false"
            formControlName="level3"
            id="plan-level3"
            aria-label="Plan level3"
            [ngClass]="{
              'is-invalid': formSubmitted && f['level3'].errors
            }">
            <ng-option value="Action Item">Action Item</ng-option>
          </ng-select>
        </div>
      </div>
      <ng-container *ngIf="isE2l && user.district && !editPlanData">
        <div class="row">
          <label for="district-select" class="form-label">District:</label>
          <div class="col-6 mb-2">
            <app-district-select
              #districtSelect
              (selectedDistrict)="updateDistrict($event)"
              [defaultDistricts]="[user.district.id]"
              [simpleSelect]="true"
              [noE2lSelectedDistrict]="true"
              [ngClass]="{
                'is-invalid': formSubmitted && f['districtId'].errors
              }" />
          </div>
        </div>
      </ng-container>
      <div class="row mb-2">
        <div class="col">
          <label class="form-label" for="plan-start-date">Start Date:</label>
          <app-datepicker
            #startDatePicker
            id="plan-start-date"
            [initialDateUnixTimestamp]="defaultStartDate"
            (dateSelectedUnixTimestamp)="updateStartDate($event)" />
        </div>
        <div class="col">
          <label class="form-label" for="plan-end-date">End Date:</label>
          <app-datepicker
            #endDatePicker
            id="plan-end-date"
            [initialDateUnixTimestamp]="defaultEndDate"
            (dateSelectedUnixTimestamp)="updateEndDate($event)" />
        </div>
      </div>
      <div class="row">
        <label for="permission-user-select" class="form-label">Sharing</label>
        <div class="col py-0 mt-0" formArrayName="permissions">
          <app-user-select
            [districtId]="isE2l ? 0 : user.district ? user.district.id : null"
            [includeE2l]="true"
            [includeDistrictAdmins]="true"
            [clearAfterSelection]="true"
            (selectedUser)="addPermission($event)" />
          <div class="row mt-2">
            <ng-container
              *ngFor="
                let permissionUser of planPermissionsUsers;
                let i = index
              ">
              <div class="my-2 col-8" *ngIf="permissionUser">
                <div class="d-flex flex-nowrap align-items-center">
                  <app-avatar
                    *ngIf="permissionUser.profile"
                    [profile]="permissionUser.profile"
                    [avatarSize]="'small'">
                  </app-avatar>
                  <div class="ms-2">
                    {{ permissionUser.profile.first_name }}
                    {{ permissionUser.profile.last_name }}
                  </div>
                </div>
              </div>
              <div
                class="col-4 d-flex align-items-center justify-content-end"
                [formGroupName]="i">
                <ng-select
                  [items]="permissionTypes"
                  bindLabel="title"
                  bindValue="value"
                  [clearable]="false"
                  [searchable]="false"
                  class="permission-type-select"
                  formControlName="permission"></ng-select>
                <button
                  aria-label="remove permission user button"
                  class="btn btn-delete btn-sm"
                  type="button"
                  ngbTooltip="Remove User"
                  [autoClose]="'outside'"
                  [ngbPopover]="popoverContent"
                  [popoverTitle]="'Remove User'"
                  #p="ngbPopover">
                  <i class="bi bi-x-circle-fill"></i>
                </button>
                <ng-template #popoverContent>
                  <div>Are you sure you wish to remove this user?</div>
                  <div class="app-hr-thin"></div>
                  <div class="text-end mt-2">
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm px-3 m-1"
                      (click)="p.close()">
                      No
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-sm px-3 m-1"
                      (click)="deletePermission(i); p.close()">
                      Yes
                    </button>
                  </div>
                </ng-template>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row">
        <label for="linkedItemsSelect" class="form-label">Linked Items</label>
        <div class="col">
          <div class="rounded-content-box">
            <app-linked-items-select
              [targetId]="editPlanData?.id || 0"
              [targetTable]="LinkedItemTargetTable.PLAN"
              [parentTableId]="editPlanData?.id || 0"
              [preloadLinkedItems]="!!editPlanData"
              [clearAfterSelection]="true"
              [districtId]="getLinkedItemsDistrictId()"
              [sources]="[
                LinkedItemSearchSource.USER,
                LinkedItemSearchSource.SCHOOL
              ]"
              [emptyStateMessage]="'Search for Users and Schools'"
              (selectedLinkedItems)="
                setLinkedItems($event)
              "></app-linked-items-select>
          </div>
        </div>
      </div>

      <div *ngIf="serverError" class="mt-3">
        <ngb-alert
          [dismissible]="true"
          [type]="'danger'"
          (closed)="serverError = ''">
          <strong>Error</strong> {{ serverError }}
        </ngb-alert>
      </div>
      <div class="mt-5 d-flex justify-content-between">
        <ng-container *ngIf="editPlanData; else create">
          <button
            class="btn"
            [autoClose]="'outside'"
            [ngbPopover]="deletePopoverContent"
            [popoverTitle]="'Delete Plan'"
            #popover="ngbPopover">
            Delete
          </button>
          <ng-template #deletePopoverContent>
            Permanently delete this plan?
            <div class="text-end mt-2">
              <button
                type="button"
                class="btn btn-secondary btn-sm px-3 m-1"
                (click)="popover.close()">
                No
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm px-3 m-1"
                (click)="popover.close(); deletePlan()">
                Yes
              </button>
            </div>
          </ng-template>
          <button
            class="btn btn-primary"
            type="submit"
            (click)="updatePlan()"
            [disabled]="isLoading">
            <span
              *ngIf="isLoading"
              class="spinner-border spinner-border-sm me-1"></span>
            Save
          </button>
        </ng-container>
        <ng-template #create>
          <button class="btn" (click)="createEditPlanModal.close()">
            Cancel
          </button>
          <button
            data-testid="create-plan-modal-save-button"
            [disabled]="isLoading"
            class="btn btn-primary"
            type="submit"
            (click)="createPlan()">
            <span
              *ngIf="isLoading"
              class="spinner-border spinner-border-sm me-1"></span>
            Create
          </button>
        </ng-template>
      </div>
    </form>
  </ng-container>
</app-modal>
